export default __webpack_public_path__ + "static/media/lock.d822b34b.svg";